import { customFieldsService } from "services";
import { listFromApiResponse } from "utils/functionsApi";

export const getAllCustomFields = (options) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try {
		const list = await customFieldsService.getAll(options);

		if (!list.ok) {
			const msg =
				list.errors?.[0]?.description ||
				"Error al cargar los campos personalizados";
			dispatch({
				type: 'ERROR',
				payload: msg
			});
			return;
		}

		dispatch({
			type: 'GET_CUSTOM_FIELDS',
			payload: listFromApiResponse(list)
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}
